/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Superset_Unlink_ShortInputs */

const en_us2_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate`)
};

const pt_br2_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separar`)
};

const es_419_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separar`)
};

const pt_pt2_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separar`)
};

const fr_fr2_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séparer`)
};

const de_de2_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trennen`)
};

const it_it2_plan_edit_superset_unlink_short = /** @type {(inputs: Plan_Edit_Superset_Unlink_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separa`)
};

/**
* | output |
* | --- |
* | "Separate" |
*
* @param {Plan_Edit_Superset_Unlink_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_superset_unlink_short = /** @type {((inputs?: Plan_Edit_Superset_Unlink_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Superset_Unlink_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_superset_unlink_short(inputs)
	if (locale === "es-419") return es_419_plan_edit_superset_unlink_short(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_superset_unlink_short(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_superset_unlink_short(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_superset_unlink_short(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_superset_unlink_short(inputs)
	return en_us2_plan_edit_superset_unlink_short(inputs)
});
export { plan_edit_superset_unlink_short as "plan-edit.superset_unlink_short" }